import { FadeUp, Eyebrow } from "./Reveal";

const VENDORS = [
  "World of Stone, Delhi",
  "Radon Tiles",
  "Somany Tiles & Sanitaryware",
  "Hindware",
  "Jaquar",
  "Kohler",
  "Prominance uPVC Windows",
  "Orient Lites, Delhi",
  "Dorby Laminates",
  "Virgo Laminates",
  "Shiva Glass, Delhi",
  "Core Hardware",
  "Three Sixty Leather",
];

export default function Vendors() {
  return (
    <section data-testid="vendors-section" className="bg-sand py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <FadeUp className="lg:col-span-4">
            <Eyebrow>Vendor association</Eyebrow>
            <h2 className="font-serif text-3xl lg:text-4xl text-ink mt-4 leading-tight">
              Specified, sourced &amp; trusted
            </h2>
            <p className="text-sm text-taupe mt-5 leading-relaxed max-w-sm">
              Long-standing relationships with stone, tile, sanitaryware, lighting, laminate and
              hardware houses — so specifications hold, samples arrive on time and site never waits.
            </p>
          </FadeUp>

          <FadeUp delay={0.1} className="lg:col-span-8">
            <div data-testid="vendor-list" className="grid grid-cols-2 sm:grid-cols-3 border-t border-l border-hairline">
              {VENDORS.map((v) => (
                <div
                  key={v}
                  className="group border-b border-r border-hairline px-5 py-7 lg:px-6 lg:py-8 bg-cream/40 hover:bg-cream transition-colors duration-300"
                >
                  <span className="block h-1 w-1 rotate-45 bg-brass/60 group-hover:bg-brass transition-colors duration-300" />
                  <p className="font-display text-[11.5px] lg:text-xs tracking-widest2 uppercase text-espresso/80 mt-5 leading-relaxed group-hover:text-ink transition-colors duration-300">
                    {v}
                  </p>
                </div>
              ))}
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
